'use strict';

var _classCallCheck = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _taggedTemplateLiteral = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  & > div {\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCustomScrollbars = require('react-custom-scrollbars');

var _Scrollbars = require('shared/contexts/Scrollbars');

var _Scrollbars2 = _interopRequireDefault(_Scrollbars);

var _animatedScrollTo = require('animated-scroll-to');

var _animatedScrollTo2 = _interopRequireDefault(_animatedScrollTo);

var _scroll = require('../../constants/scroll');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
} // fixme: move scrollToId to state or parent context
// scrollToId should be kept on change of page
// and scrollbar context provider cannot be moved above routes initialization
// as it requires reference for DOM element of the layout but layout shown depending to given route


var scrollToId = null;
var StyledScrollBars = (0, _styledComponents2.default)(_reactCustomScrollbars.Scrollbars)(_templateObject(), function (props) {
  return props.disabled && 'overflow: hidden !important;';
});

var ScrollbarProvider =
/*#__PURE__*/
function (_react$Component) {
  _inherits(ScrollbarProvider, _react$Component);

  function ScrollbarProvider() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ScrollbarProvider);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ScrollbarProvider)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.scrollBarWrapper = _react2.default.createRef(), _this.scroll = {
      prevScrollTop: 0,
      direction: null
    }, _this.state = {
      needToFixedHeaders: false,
      mobileMenuStatus: false
    }, _this.scrollTo = function (id) {
      scrollToId = id;
    }, _this.onScrollTo = function (callback) {
      if (scrollToId) {
        callback(scrollToId, _this.setScroll);
        scrollToId = null;
      }
    }, _this.setScroll = function (offset, options) {
      (0, _animatedScrollTo2.default)(offset, _extends({
        element: _this.scrollBarWrapper.current.parentNode
      }, options));
    }, _this.setScrollInfo = function (e) {
      var prevScrollTop = _this.scroll.prevScrollTop;

      if (e.srcElement.scrollTop > prevScrollTop) {
        _this.scroll.direction = _scroll.DOWN;
      } else {
        _this.scroll.direction = _scroll.UP;
      }

      _this.scroll.prevScrollTop = e.srcElement.scrollTop;
    }, _this.isNeedFixedTitles = function () {
      var needToFixedHeaders = _this.state.needToFixedHeaders;
      var forwardRef = _this.props.forwardRef;
      var direction = _this.scroll.direction;
      var isFixed = false;
      if (!forwardRef.current) return;

      if (direction === _scroll.UP) {
        if (forwardRef.current.viewScrollTop === 0) {
          isFixed = false;
        } else if (forwardRef.current.viewScrollTop > _scroll.HEIGHT_TO_ALLOW_SCROLL) {
          isFixed = true;
        }
      } else if (forwardRef.current.viewScrollTop > _scroll.HEIGHT_TO_ALLOW_SCROLL) {
        isFixed = false;
      }

      if (isFixed !== needToFixedHeaders) {
        _this.setState(function () {
          return {
            needToFixedHeaders: isFixed
          };
        });
      }
    }, _this.handleOnScroll = function (e) {
      _this.setScrollInfo(e);

      _this.isNeedFixedTitles();
    }, _this.handleMobileMenuStatus = function (status) {
      _this.setState({
        mobileMenuStatus: status
      });
    }, _temp));
  }

  _createClass(ScrollbarProvider, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          forwardRef = _props.forwardRef,
          props = _objectWithoutProperties(_props, ['forwardRef']);

      var _this$state = this.state,
          needToFixedHeaders = _this$state.needToFixedHeaders,
          mobileMenuStatus = _this$state.mobileMenuStatus;
      var context = {
        wrapper: this.scrollBarWrapper.current,
        scrollTo: this.scrollTo,
        onScrollTo: this.onScrollTo,
        needToFixedHeaders: needToFixedHeaders,
        handleMobileMenuStatus: this.handleMobileMenuStatus
      };
      return _react2.default.createElement(StyledScrollBars, _extends({
        disabled: mobileMenuStatus
      }, props, {
        ref: forwardRef,
        onScroll: this.handleOnScroll
      }), _react2.default.createElement('div', {
        ref: this.scrollBarWrapper
      }, _react2.default.createElement(_Scrollbars2.default.Provider, {
        value: context
      }, this.props.children)));
    }
  }]);

  return ScrollbarProvider;
}(_react.Component);

exports.default = ScrollbarProvider;